import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { NacoService } from './domains/services/naco.service';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { NacoViewModule } from './views/module';
import { Config } from './domains/values/config';

const NACO_ROOT_CONFIG = new InjectionToken('NACO_ROOT_CONFIG');

export function nacoConfigFactory(config: Config) {
    return new Config(config);
}

@NgModule({
    imports: [NacoViewModule],
})
export class NacoModule {
    public static forRoot(config: Config): ModuleWithProviders<NacoModule> {
        return {
            ngModule: NacoModule,
            providers: [
                {
                    provide: NACO_ROOT_CONFIG,
                    useValue: config,
                },
                {
                    provide: Config,
                    useFactory: nacoConfigFactory,
                    deps: [NACO_ROOT_CONFIG],
                },
                NacoService,
                AuthenticatedGuard,
            ],
        };
    }
}
